// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue';
import VueAnalytics from 'vue-analytics';
import App from './App';
import router from './router';


Vue.config.productionTip = false;

require('./assets/css/main.css');
require('./assets/favicon.ico');
require('./assets/favicon-16x16.png');
require('./assets/favicon-32x32.png');

/* eslint-disable no-new */
new Vue({
  el: '#app',
  router,
  template: '<App/>',
  components: { App },
});

if (navigator.userAgent.indexOf('Speed Insights') === -1) {
  Vue.use(VueAnalytics, {
    id: 'UA-44706150-1',
    router,
  });
}



// WEBPACK FOOTER //
// ./src/main.js